import React from "react";
import Aboutsec from "../Menabout/Aboutsec";
// import Aboutservice from '../Menabout/Aboutservice'
import Testimonialsabout from '../Menabout/Testimonialsabout';
import Bredcrumb from "../Bredcrumb/Main";
import Sliderabout from "../Menabout/Sliderabout";
import Teem from "../Menhome/Teem";

import Img from "../../assets/images/background/restaurant-canmore-Staff.jpg";

function Main() {
    return (
        <>
            <Bredcrumb subtitle="About Us" title="OUR STORY" Img={Img} />
            <Aboutsec />
            <Teem />
            <Sliderabout />
            <Testimonialsabout />
            {/* <Aboutwhyus /> */}
        </>
    );
}
export default Main;
